<template>
  <div class="page">
    <van-tabs v-model="activeType" @change="changeActiveType" title-active-color="#408CF8" color="#408CF8">
      <van-tab title="全部" name="all"></van-tab>
      <van-tab title="待办理" name="10"></van-tab>
      <van-tab title="已办理" name="40"></van-tab>
      <van-tab title="已取消" name="20"></van-tab>
      <van-tab title="已过期" name="30"></van-tab>
    </van-tabs>
    <van-list
        style="margin-top: 20px;"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        v-model="loading"
        :finished="finished"
        finished-text="已加载完毕"
        @load="loadData"
    >
      <div @click="handleClick(item)" v-for="item in list" :key="item.id" class="item">
        <div class="title"></div>
        <div class="content">
          <div class="content-item">
            <div>
              <van-icon name="clock-o"/>
              预约日期
            </div>
            <div>{{ item.planDate }} / {{ item.planStartTime }}-{{ item.planEndTime }}</div>
          </div>
          <div class="content-item">
            <div>
              <van-icon name="setting-o"/>
              预约状态
            </div>
            <div class="status">{{ item.applyStatus | applyStatusFilter }}</div>
          </div>
          <div class="content-item">
            <div>
              <van-icon name="user-circle-o"/>
              申请时间
            </div>
            <div>{{ item.applyDateTime }}</div>
          </div>
          <div class="content-item" v-if="item.dealDateTime">
            <div>
              <van-icon name="passed"/>
              办理时间
            </div>
            <div>{{ item.dealDateTime }}</div>
          </div>
          <template v-if="item.applyStatus === 20">
            <div class="content-item">
              <div>
                <van-icon name="clock-o"/>
                取消时间
              </div>
              <div>{{ item.cancelDateTime }}</div>
            </div>
            <div class="content-item">
              <div style="width: 200px;">
                <van-icon name="close"/>
                取消原因
              </div>
              <div>{{ item.cancelReason }}</div>
            </div>
          </template>
          <div class="content-item">
            <div>
              <van-icon name="todo-list-o"/>
              申请业务及要求：
            </div>
            <div>
            </div>
          </div>
          <div v-for="service in item.serviceList">
            <van-divider :style="{ margin: '0 0', color:'#000' }">{{ service.title }}</van-divider>
            <div v-html="service.requirement" style="white-space: pre-wrap;padding: 5px 8px;font-size: 13px;"></div>
          </div>
          <div v-if="item.applyStatus === 10">
            <van-divider></van-divider>
            <div style="text-align: right;">
              <van-button size="small" @click="handleClickBarCode(item)" style="margin-left: 8px;" type="primary">
                查看二维码
              </van-button>
              <van-button size="small" @click="handleClickCancel(item)" style="margin-left: 8px;" type="warning">取消预约
              </van-button>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <van-dialog v-model="showBarCode" :showCancelButton="false" title="预约二维码">
      <div id="qrcode" ref="qrcode"/>
    </van-dialog>
    <van-dialog v-model="showCancelDialog" title="取消预约" :showCancelButton="true" :before-close="handleCloseCancel">
      <div>
        <div></div>
        <van-field
            v-model.trim="cancelReason"
            label-width="70px"
            required
            show-word-limit
            :maxlength="100"
            type="textarea"
            clearable
            placeholder="请填写取消原因"
            label="取消原因"
        />
      </div>
    </van-dialog>
    <!--    <van-button @click="handleGoApply" style="position: fixed;bottom: 0;right: 0;left: 0;width: 100%;" type="info">去预约-->
    <!--    </van-button>-->
  </div>
</template>
<style scoped="scoped">
.page {
  padding: 0 0px 55px 0;
  box-sizing: border-box;
}

.item {
  position: relative;
  display: flex;
  flex-direction: column;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 10px 10px;
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
}

.item .title {
  font-size: 18px;
  margin-bottom: 10px;
  font-weight:500;
}

.item .status {
  color: #1989fa;
}

.content {
  display: flex;
  font-size: 14px;
  flex-direction: column;
}

.content-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 3px;
}

#qrcode {
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script>
import QRCode from 'qrcodejs2';
import nativeApi from '@/utils/native-bridge';
import {applyList as getList, cancelApply} from '@/api/reservation.js';
import {createFilter} from '@/utils/sys-dict.js';
import loadMixin from '@/mixin/mixin-load.js';
import {Dialog} from "vant";
import moment from "moment";

export default {
  components: {},
  mixins: [loadMixin],
  filters: {
    applyStatusFilter: createFilter('applyStatus')
  },
  data() {
    return {
      query: {
        limit: 10,
        page: 0
      },
      activeType: 'all',
      list: [],
      loading: false,
      finished: false,
      error: false,
      showBarCode: false,
      showCancelDialog: false,
      cancelReason: '',
      apply: null
    };
  },
  methods: {
    changeActiveType() {
      this.refreshData();
    },
    handleClick(item) {
      if (item.linkUrl) {
        nativeApi.forwardPage({
          uri: item.linkUrl
        });
      }
    },
    clearChild(ele) {
      var childs = ele.childNodes;
      for (var i = childs.length - 1; i >= 0; i--) {
        ele.removeChild(childs[i]);
      }
    },
    handleClickBarCode(item) {
      this.showBarCode = true;
      this.$nextTick(() => {
        this.clearChild(this.$refs.qrcode);
        let qrcode = new QRCode('qrcode', {
          width: 200,
          height: 200, // 高度
          text: item.uuid // 二维码内容
          // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f'
          // foreground: '#ff0'
        });
      });
    },
    handleClickCancel(item) {
      const nowDate = moment().format('YYYY-MM-DD');
      const planStartDateStr = item.planDate;
      console.log(planStartDateStr);
      // const planStartDateTime = moment(`${planStartDateStr} ${item.planStartTime}:00`);
      // const nowDateTime = new Date().getTime();
      // 当天和以后不能取消
      if (nowDate > planStartDateStr) {
        Dialog.alert({title: '温馨提示', message: '已过预约的办理时间，不能取消预约'})
      } else if (nowDate == planStartDateStr) {
        //距离预约时间段24小时内，，可以取消，但提示爽约
        Dialog.confirm({
          title: '温馨提示',
          message: '当前时间已临近您预约的办理时间，现在取消预约将会被记入爽约，是否继续？',
          confirmButtonText: '继续取消'
        }).then(() => {
          this.showTip('请填写取消原因');
          this.apply = item;
          this.showCancelDialog = true;
        }).catch(() => {
          // on cancel
        });
      } else {
        this.apply = item;
        this.showCancelDialog = true;
      }
    },
    handleCloseCancel(action, done) {
      if (action === 'cancel') {
        done();
        return;
      }
      if (!this.cancelReason) {
        this.showErrorTip('请填写取消原因');
        done(false);
        return;
      }
      cancelApply({uuid: this.apply.uuid, reason: this.cancelReason})
          .then(rep => {
            this.showSuccessTip('处理成功');
            this.refreshData();
            done(true);
          })
          .catch(() => {
            done(false);
          });
    },
    refreshData() {
      this.query.page = 0;
      this.list = [];
      this.loadData();
    },
    loadData() {
      this.loading = true;
      const targetPage = this.query.page + 1;
      const request = Object.assign({}, this.query, {
        page: targetPage
      });
      if (this.activeType !== 'all') {
        request.applyStatus = this.activeType;
      }
      getList(request)
          .then(({data}) => {
            this.query.page = targetPage;
            if (data.items && data.items.length) {
              this.list = this.list.concat(data.items);
              this.loading = false;
            } else {
              this.finished = true;
              this.loading = false;
            }
          })
          .catch(rep => {
            this.error = true;
            this.loading = false;
          });
    },
    handleGoApply() {
      this.$router.replace({
        path: '/reservation'
      });
    }
  },
  created() {
    // this.loadData();
  }
};
</script>
